$(document).ready(function() {
	
	// autocomplete form functionality
	if ($('#autocomplete-form').length > 0) {
		autocomplete();
		initialSearchForm();
	}
	
	// find parking form modal
	$('.tru-find-parking-modal-trigger').on('click', function(e) {
		e.preventDefault();
		$('body').addClass('tru-find-parking-modal-active');
	});
	
	// click button to close modal
	$('.tru-modal-button-close').on('click', function(e) {
		e.preventDefault();
		if ($('body').hasClass('tru-find-parking-modal-active')) {
			$('body').removeClass('tru-find-parking-modal-active');
		}
	});
	
	// hit esc key to close modal
	$(document).on('keydown', function(e) {
		if ($('body').hasClass('tru-find-parking-modal-active') && e.keyCode == 27) {
			$('body').removeClass('tru-find-parking-modal-active');
		}
	});
	
	// client logos slider
	var logos_group = $('.tru-client-logos-group');
	$(logos_group).each(function(index, group) {
		$(group).flickity({
			callAlign: 'left',
			pageDots: false,
			wrapAround: true
		});
	});
	
	// filter and sort property cards
	if ($('.tru-sortable-cards-mixitup').length) {
		var mixer = mixitup('.tru-sortable-cards-mixitup', {
			animation: {
				effects: 'fade scale',
				duration: 500,
				easing: 'ease-in-out'
			},
			debug: {
				enable: true
			},
			load: {
				sort: 'order:asc'
			},
			multifilter: {
				enable: false
			},
			selectors: {
				target: '.tru-sortable-card'
			}
		});
	}
	
	// single facility form switcher
	$('.tru-facility-forms').each(function(index, group) {
		$('.tru-facility-forms-choice', group).on('click', function(event) {
			event.preventDefault();
			var form = $(this).attr('data-form');
			console.log('form:', form);
			$('.tru-facility-forms-choice', group).removeClass('tru-facility-forms-choice-active');
			$('.tru-facility-forms-choice[data-form="' + form + '"]', group).addClass('tru-facility-forms-choice-active');
			$('.tru-facility-form', group).removeClass('tru-facility-form-active');
			$('.tru-facility-form[data-form="' + form + '"]', group).addClass('tru-facility-form-active');
		});
	});
	
});